import React from 'react';
import HomeContainer from 'containers/HomeContainer';

type Props = {};

export default function HomePage({}: Props) {
  return <HomeContainer />;
}
